import {Component, Input} from '@angular/core';

import {HsDialogContainerService} from 'hslayers-ng';

import {
  AdjusterPresetsService,
  Dataset,
  Label,
} from '../adjuster-presets.service';
import {MetadataDialogComponent} from '../metadata-dialog/metadata-dialog.component';

@Component({
  selector: 'pra-dataset-item',
  templateUrl: 'dataset-item.component.html',
})
export class DatasetItemComponent {
  @Input() dataset: Dataset;
  //descriptionVisible = false;

  constructor(
    public adjusterPresetsService: AdjusterPresetsService,
    public hsDialogContainerService: HsDialogContainerService
  ) {}

  getLabelInCurrentLang(labels: Label[]) {
    return this.adjusterPresetsService.getLabelInCurrentLang(labels);
  }

  showMetadataWindow(dataset: Dataset) {
    this.hsDialogContainerService.create(MetadataDialogComponent, {
      id: dataset.id,
      desc: dataset.desc,
    });
  }
}
